import { render, staticRenderFns } from "./SendMessageDialogWrapper.vue?vue&type=template&id=6934e0a4&scoped=true"
import script from "./SendMessageDialogWrapper.vue?vue&type=script&lang=ts"
export * from "./SendMessageDialogWrapper.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDialogWrapper.vue?vue&type=style&index=0&id=6934e0a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934e0a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6934e0a4')) {
      api.createRecord('6934e0a4', component.options)
    } else {
      api.reload('6934e0a4', component.options)
    }
    module.hot.accept("./SendMessageDialogWrapper.vue?vue&type=template&id=6934e0a4&scoped=true", function () {
      api.rerender('6934e0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/SendMessageDialogWrapper.vue"
export default component.exports